import React from 'react'

import { breakpoints, SmartImage } from 'main/ui'

interface IProps {
  mapView?: boolean
  url: string
}

export default function Photo(props: IProps) {
  const { url, mapView } = props

  return (
    <SmartImage
      critical
      css={{ borderRadius: '3px' }}
      width={mapView ? 100 : breakpoints.sm}
      height={mapView ? 130 : (breakpoints.sm / 16) * 9}
      src={url}
    />
  )
}
